import { mc, StyleProps } from '@styles';
import React, { FC, ReactNode } from 'react';

import ChevroneLeftIcon from './assets/chevronLeft.inline.svg';

interface Props extends StyleProps {
  children: ReactNode;
  onClick?: () => void;
}

export const MobileDropdownBackBtn: FC<Props> = ({ className, onClick, children }) => {
  return (
    <button
      className={mc('px-10 py-9', 'flex flex-row justify-start items-center', 'bg-light-gray', className)}
      role="button"
      onClick={onClick}
    >
      <ChevroneLeftIcon className="inline-block" />
      <span className="ml-3 inline-block uppercase font-raleway leading-normal font-bold text-ocean-blue">{children}</span>
    </button>
  );
};

export type MobileDropdownBackBtnProps = Props;
export default MobileDropdownBackBtn;
